angular.module('impactx.rfx').controller('RFXBuyerDecideCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    'ToolbarService',
    'ToastService',
    'BackService',
    'TranslationService',
    'RFXBuyerService',
    RFXBuyerDecideController
]);

function RFXBuyerDecideController($scope, $routeParams, dataGen, ToolbarService, ToastService, BackService, TranslationService, RFXBuyerService) {

    var self = this;
    var selectedSupplier = undefined;
    self.selectedItem = undefined;

    dataGen.getData($scope, {rfqhId: $routeParams.rfqhId}, '/rfx/buyer/decision/view').then(function () {
        defineButtons();
        angular.forEach($scope.data.suppliers, function (supplier) {
            if (supplier && supplier.selected) {
                selectedSupplier = supplier;
            }
        });
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.decide,
                action: self.decide,
                condition: canDecide
            },
            {
                label: $scope.trns.compare,
                linkFunction: self.getCompareLink,
                type: 'link',
                condition: canCompare
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    self.selectSupplier = function (supplier) {
        if (selectedSupplier && selectedSupplier === supplier) {
            supplier.selected = false;
            selectedSupplier = undefined;
        }
        else {
            if (selectedSupplier) {
                selectedSupplier.selected = false;
            }
            supplier.selected = true;
            selectedSupplier = supplier;
        }
    };

    function decideInternal(rfqsId) {
        return dataGen.postAsForm($scope, {rfqsId: rfqsId}, "/rfx/buyer/decide").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    }

    self.decide = function (event) {
        if ($scope.data.useTextCustomization) {
            return RFXBuyerService.showTextCustomization(event, $routeParams.rfqhId, RFXBuyerService.STATUS.DECIDED, [selectedSupplier.rfqsId]).then(function () {
                return decideInternal(selectedSupplier.rfqsId);
            });
        }
        else {
            return decideInternal(selectedSupplier.rfqsId);
        }
    };

    self.selectItem = function (selectedItem) {
        if (self.selectedItem === selectedItem) {
            self.selectedItem = undefined;
        }
        else {
            self.selectedItem = selectedItem;
        }
    };

    self.getCompareLink = function () {
        return "rfxitemcompare/" + self.selectedItem.rfqiGroupId;
    };

    function canCompare() {
        return !!self.selectedItem;
    }

    function canDecide() {
        return !!selectedSupplier && !self.selectedItem;
    }
}